import { Box, Typography, Link } from "@mui/material";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#1D4E5C",
        color: "white",
        padding: { xs: "12px 16px", md: "16px 24px" },
        marginTop: "auto",
        textAlign: "center",
        width: "100%",
        marginLeft: 0,
        marginRight: 0,
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: "1rem",
          fontFamily: "ABC Whyte",
        }}
      >
        © {currentYear} Camp Australia. All rights reserved.
      </Typography>
      <Box sx={{ mt: 1, display: "flex", justifyContent: "center", gap: 2, flexWrap: "wrap" }}>
        <Link
          href="https://www.campaustralia.com.au/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="footerlink"
          sx={{
            color: "#5CE5BB",
            textDecoration: "none",
            fontSize: "1rem",
            height: "44px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 16px",
            lineHeight: 1.5,
            boxSizing: "border-box",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Privacy Policy
        </Link>
        <Link
          href="https://www.campaustralia.com.au/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="footerlink"
          sx={{
            color: "#5CE5BB",
            textDecoration: "none",
            fontSize: "1rem",
            height: "44px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 16px",
            lineHeight: 1.5,
            boxSizing: "border-box",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Terms & Conditions
        </Link>
      </Box>
    </Box>
  );
}

export default Footer;
